import React from "react";
import PropTypes from "prop-types";

import "./PartnerApp.css";

const typeTitle = {
  title: "partner-app__title-regular",
  description: ""
};

const PartnerApp = ({ name, title, subtitle, img, type }) => {
  return (
    <div className={`partner-app__container ${typeTitle[type]}`}>
      <img src={img} alt="Title" />
      <div className="partner-app__description">
        <div>
          {name && <span>{name} - </span>}
          {title}
        </div>
        <div>{subtitle}</div>
      </div>
    </div>
  );
};

PartnerApp.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  img: PropTypes.string,
  type: PropTypes.string.isRequired
};

export default PartnerApp;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/spocketDeals/PartnerApp.js